module.exports = __webpack_public_path__ + "media/images/pic/teachers/owner-f32f9495b147191132214d1d76d38b37.png";